"use client";

import React, { useEffect, useRef, useState } from "react";
import { Building2, Bed, Utensils, Store, Home } from "lucide-react";
const clients = [{
  title: "Bureaux",
  icon: Building2
}, {
  title: "Hôtels",
  icon: Bed
}, {
  title: "Restaurants",
  icon: Utensils
}, {
  title: "Boutiques",
  icon: Store
}, {
  title: "Résidentiel",
  icon: Home
}];
export default function OurClients() {
  const sectionRef = useRef<HTMLElement>(null);
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const viewHeight = window.innerHeight;
      if (rect.top <= viewHeight && rect.bottom >= 0) {
        const scrollProgress = (viewHeight - rect.top) / (viewHeight + rect.height);
        setOffset((scrollProgress - 0.5) * 60);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="nos-clients" className="bg-background" ref={sectionRef}>
      <div className="bg-primary py-24 md:py-32 px-6 overflow-hidden">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-16 gap-x-8 justify-items-center">
            {clients.map((client, i) => {
            const Icon = client.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center w-full max-w-[160px]" style={{
              transform: `translateY(${offset}px)`,
              willChange: "transform"
            }}>
                  <div className="size-20 rounded-full border border-ring flex items-center justify-center mb-6 bg-primary/50 backdrop-blur-sm shadow-xl transition-colors duration-500 hover:bg-ring/10">
                    <Icon className="size-8 text-ring" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-sans uppercase tracking-widest text-primary-foreground text-xs md:text-sm font-medium text-center">
                    {client.title}
                  </h3>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}